import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaCargaHorariaProfessorSintetico(props) {
    const { estrutura } = props;
    const { professores } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "Professores",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Nome',
                    accessor: 'professor',
                },
                {
                    Header: 'Tipos de Atividade',
                    accessor: 'tipos_atividade',
                },
                {
                    Header: 'Carga Horária',
                    accessor: 'carga_horaria',
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"
            {...props}
        >
            <Tabela
                columns={columns}
                data={professores}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaCargaHorariaProfessorSintetico;
